module.exports = "<div class=\"ui negative icon message\">\r\n  <i class=\"minus circle icon\"></i>\r\n  <div class=\"content\">\r\n    <div class=\"header\">\r\n      Khu vực hạn chế truy cập\r\n    </div>\r\n    <p>Vui lòng đăng nhập để tiếp tục.</p>\r\n\r\n    <button class=\"ui button\" (click)=\"auth.login()\">Đăng nhập</button>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main